<template>

    <section :id="component.identifier ? component.identifier : ''"  class="mb-64" v-if="show" ref="container">

        <component-header :title="title" :description="description"></component-header>

        <gallery-single
            v-if="isSingleImage"
            :caption="translated(component.caption)"
            :image="component.images[0]">
        </gallery-single>

        <gallery-marquee
            v-else-if="isMarquee"
            :images="component.images">
        </gallery-marquee>

    </section>

</template>

<script>
import ComponentHeader from './ComponentHeader.vue';
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import GallerySingle from './GallerySingle.vue';
import GalleryMarquee from './GalleryMarquee.vue';
import { runningInBrowser } from '../../helpers';
import imagesloaded from 'imagesloaded';

export default {
    components: {
        'component-header': ComponentHeader,
        'gallery-single': GallerySingle,
        'gallery-marquee': GalleryMarquee,
    },
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {
            type: 'marquee',
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return this.component.images && !!this.component.images.length;
        },
        isMarquee () {
            return this.type === 'marquee';
        },
        isSingleImage () {
            return this.component.images.length === 1;
        },
        title: {
            get () {
                return this.translated(this.component.title);
            }
        },
        description: {
            get () {
                return this.translated(this.component.description);
            }
        }
    },
    mounted () {
        imagesloaded(this.$refs.container, instance => {
            this.$emit('loaded');
        });
    }
}
</script>
